export const QUERY_PARAM = {
    CLIENT_ID: "clientId",
    CLIENT_SECRET: "clientSecret",
    EXPIRY_TIME: "expiryTime",
    GRANT_TYPE: "grantType",
    INDUSTRIES_CATEGORY_ID: "industry",
    NO_RESULTS_FOUND_DESCRIPTION: "No results were found that matched the query.",
    NO_RESULTS_FOUND: "No Result Found",
    PAGE_SIZE: "pageSize",
    PAGE: "page",
    REFRESH_TOKEN: "refreshToken",
    SEARCH_TERM: "q",
    STRUCTURE_ID: "structureId",
    TECHNOLOGY_CATEGORY_ID: "technology",
    TOKEN: "token"
};